module.exports = {"id":"235790","name":"Kai Havertz","rating":"76","photo":"./data/images/photos/3/235790.png","club":{"name":"Bayer 04","logo":"./data/images/clubs/Bayer04.png"},"positions":["MD","MOC","ATT"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KaiHavertz0.json
// module id = 2274
// module chunks = 0